/**
 * Taggable Service
 * Register Angular Services for all things Tags
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 * @return Resource
 */
import angular from 'angular';

angular.module('flsServices').factory('Tag', ['$resource', function($resource){
    return $resource('/api/v3/tags/:path:id', {
        id: '@id',
        path: '@path',
    }, {
        'create':{
            method:'GET',
            params:{
                path:'create'
            }
        }
    });
}]);
